<template>
  <div class="grid bg-white">
    <div class="grid-title mb-0">
      <table class="table mb-0">
        <tbody>
          <tr>
            <td>
              <datepicker
                :clear-button="true"
                placeholder="Select Date"
                v-model="params.dateFilters.from"
                input-class="form-control"
              >
              </datepicker>
            </td>
            <td>
              <datepicker
                :clear-button="true"
                placeholder="Select Date"
                v-model="params.dateFilters.to"
                input-class="form-control"
              >
              </datepicker>
            </td>
            <td class="text-right">
              <input
                type="text"
                v-model="params.keyword"
                placeholder="Keywrod ..."
                @keyup.enter="filter()"
              />
              <button class="btn btn-primary" @click="filter()">
                <i class="fa fa-search" aria-hidden="true"></i> Search
              </button>
            </td>
            <td class="text-right">
              <router-link
                class="btn btn-success"
                :to="{ path: '/accounting/expenditure/invoice/create' }"
                v-if="this.$route.params.type == 'expenditure'"
              >
                <i class="fa fa-plus-circle" aria-hidden="true"></i>
                Create New
              </router-link>
              <router-link
                class="btn btn-success"
                :to="{ path: '/accounting/sale_and_revenue/invoice/create' }"
                v-else
              >
                <i class="fa fa-plus-circle" aria-hidden="true"></i>
                Create New
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <expense-lists
      v-if="this.$route.params.type == 'expenditure'"
      :invoices="invoices"
      :loading="loading"
      :noMoreData="noMoreData"
      @delete="delInvoice(index)"
    />

    <revenue-lists
      v-else
      :invoices="invoices"
      :loading="loading"
      :noMoreData="noMoreData"
      @delete="delInvoice(index)"
    />
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import Swal from "sweetalert2";
import ezy from "./Tools/ezyFunction";
import ExpenseLists from "./Components/ExpenseLists";
import RevenueLists from "./Components/RevenueLists";

export default {
  components: {
    Datepicker,
    ExpenseLists,
    RevenueLists,
  },
  data() {
    return {
      invoices: [],
      canScroll: false,
      loading: false,
      noMoreData: false,
      params: {
        keyword: null,
        sort: { column: "id", type: "desc" },
        dateFilters: {
          from: null,
          to: null,
          column: "invoice_date",
        },
        page: 1,
        limit: 50,
        type: this.$route.params.type,
      },
      moment,
      ezy,
    };
  },
  watch: {
    $route: function () {
      this.invoices = [];
      this.params = {
        keyword: null,
        sort: { column: "id", type: "desc" },
        dateFilters: {
          from: null,
          to: null,
          column: "invoice_date",
        },
        page: 1,
        limit: 50,
        type: this.$route.params.type,
      };
      this.getInvoices();
    },
  },
  mounted() {
    this.getInvoices();
    this.scroll();
  },
  methods: {
    filter() {
      this.invoices = [];
      this.params.page = 1;
      this.getInvoices();
    },
    async getInvoices() {
      this.loading = true;
      let res = await axios.get("accounting/invoice", { params: this.params });
      let invoices = res.data;
      invoices.forEach((val) => {
        val["show"] = false;
        this.invoices.push(val);
      });
      if (invoices.length < this.params.limit) {
        this.canScroll = false;
        this.noMoreData = true;
      } else {
        this.params.page++;
        this.canScroll = true;
        this.noMoreData = false;
      }
      this.loading = false;
    },
    scroll() {
      var self = this;
      window.onscroll = () => {
        var elem = document.getElementsByClassName("page-content")[0];
        if (self.canScroll == true && self.noMoreData == false) {
          if (
            document.documentElement.scrollTop +
              document.documentElement.offsetHeight >=
            elem.scrollHeight
          ) {
            self.canScroll = false;
            self.getInvoices();
          }
        }
      };
    },
    async delInvoice(index) {
      let data = this.invoices[index];
      const { value: value } = await Swal.fire({
        type: "warning",
        title: "Are You Sure",
        confirmButtonText: "YES",
        showCancelButton: true,
      });
      if (value) {
        let res = await axios.delete("accounting/invoice/" + data.id);
        if (res) {
          this.invoices.splice(index, 1);
          toastr.success("Successfully Deleted !");
        }
      }
    },
  },
};
</script>
